module.exports = __webpack_public_path__ + "media/images/vp/icon.noaccount.white-8f4bac10c750aec2236d3870d3ca4629.svg";